import { defineClassNames } from '../../utils/defineClassNames';

export const classes = defineClassNames('media-overlay-drag-handle', {
  root: {},
});
